module.exports = __webpack_public_path__ + "img/cv.09892c03.png";